import AccountView from "./AccountView";

export default AccountView;